/**
 * Typed reads for normalized code containers (`state.entities.transforms`).
 *
 * `getCodeContainer` / `createCodeContainer` / `updateCodeContainer`
 * (js/actions/transform) normalize their responses into this map, keyed by
 * container id.
 */

export interface CodeContainerEntity {
  id: number | string;
  name?: string;
  reusable?: boolean;
  resource_type?: string;
  code?: unknown;
  code_encoding?: string;
  code_config?: {
    packages?: string;
    extra_data?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export type CodeContainersById = Record<string | number, CodeContainerEntity | undefined>;

export interface TransformsRootState {
  entities?: { transforms?: CodeContainersById };
}

// Stable fallback so a missing map doesn't hand useSelector a new object on
// every call (which would force a re-render on each store update).
const EMPTY_TRANSFORMS: CodeContainersById = Object.freeze({}) as CodeContainersById;

export function selectCodeContainersById(state: TransformsRootState): CodeContainersById {
  return state?.entities?.transforms ?? EMPTY_TRANSFORMS;
}
